import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Collapse, Modal, Button, Alert } from "react-bootstrap";

const AddEvent = () => {
  const [collapseBtn, setCollapseBtn] = useState(true);
  const [events, setEvents] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    subtitle: "",
    description: "",
    event_date: "",
    location: "",
  });

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  // PROFESSIONAL ALERT
  const [alert, setAlert] = useState({
    show: false,
    type: "",
    text: "",
  });

  // DELETE CONFIRM MODAL
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // EDIT STATE
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editImage, setEditImage] = useState(null);
  const [editData, setEditData] = useState({
    title: "",
    subtitle: "",
    description: "",
    event_date: "",
    location: "",
    image: "",
  });

  // SHOW ALERT
  const showAlert = (type, text) => {
    setAlert({ show: true, type, text });
    setTimeout(() => {
      setAlert({ show: false, type: "", text: "" });
    }, 3000);
  };

  // FETCH EVENTS
  const fetchEvents = async () => {
    try {
      const res = await fetch("https://admin.vascularirdoctors.com/backend/events");
      const data = await res.json();
      setEvents(data);
    } catch (err) {
      console.log("FETCH EVENTS ERROR:", err);
      showAlert("danger", "Unable to fetch events.");
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  // FORM CHANGE
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImage = (e) => {
    setImage(e.target.files[0]);
  };

  // ADD EVENT
  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      data.append("title", formData.title);
      data.append("subtitle", formData.subtitle);
      data.append("description", formData.description);
      data.append("event_date", formData.event_date);
      data.append("location", formData.location);
      if (image) data.append("image", image);

      const res = await fetch("https://admin.vascularirdoctors.com/backend/events", {
        method: "POST",
        body: data,
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Event added successfully.");
        setFormData({
          title: "",
          subtitle: "",
          description: "",
          event_date: "",
          location: "",
        });
        setImage(null);
        fetchEvents();
      } else {
        showAlert("danger", result.message || "Failed to add event.");
      }
    } catch (err) {
      console.log("EVENT SUBMIT ERROR:", err);
      showAlert("danger", "Unable to connect to server.");
    }

    setLoading(false);
  };

  // DELETE EVENT
  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const deleteEvent = async () => {
    try {
      const res = await fetch(`https://admin.vascularirdoctors.com/backend/events/${deleteId}`, {
        method: "DELETE",
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Event deleted successfully.");
        fetchEvents();
      } else {
        showAlert("danger", result.message || "Delete failed.");
      }
    } catch (err) {
      console.log("DELETE ERROR:", err);
      showAlert("danger", "Unable to delete event.");
    }

    setShowDeleteModal(false);
    setDeleteId(null);
  };

  // OPEN EDIT
  const openEditModal = (event) => {
    setEditId(event.id);
    setEditData({
      title: event.title || "",
      subtitle: event.subtitle || "",
      description: event.description || "",
      event_date: event.event_date || "",
      location: event.location || "",
      image: event.image || "",
    });
    setEditImage(null);
    setShowModal(true);
  };

  // EDIT INPUT CHANGE
  const handleEditChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditImage = (e) => {
    setEditImage(e.target.files[0]);
  };

  // UPDATE EVENT
  const updateEvent = async () => {
    try {
      const data = new FormData();
      data.append("title", editData.title);
      data.append("subtitle", editData.subtitle);
      data.append("description", editData.description);
      data.append("event_date", editData.event_date);
      data.append("location", editData.location);
      if (editImage) data.append("image", editImage);

      const res = await fetch(`https://admin.vascularirdoctors.com/backend/events/${editId}`, {
        method: "PUT",
        body: data,
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Event updated successfully.");
        setShowModal(false);
        fetchEvents();
      } else {
        showAlert("danger", result.message || "Update failed.");
      }
    } catch (err) {
      console.log("UPDATE ERROR:", err);
      showAlert("danger", "Unable to update event.");
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row page-titles align-items-center">
            <div className="col-sm-6">
              <ol className="breadcrumb mt-sm-0 mt-2">
                
                <li className="breadcrumb-item active" aria-current="page">
                  Add Event
                </li>
              </ol>
            </div>

            {/* TOP RIGHT CLOSE BUTTON */}
            <div className="col-sm-6 text-sm-end mt-2 mt-sm-0">
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={() => setCollapseBtn(false)}
              >
                <i className="fas fa-times me-1"></i> Close
              </button>
            </div>
          </div>
        </div>

        {/* ALERT */}
        {alert.show && (
          <div className="col-xl-12">
            <Alert variant={alert.type} className="shadow-sm rounded-3">
              {alert.text}
            </Alert>
          </div>
        )}

        {/* ADD FORM */}
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className="content-title d-flex justify-content-between align-items-center">
              <div className="cpa">
                <i className="fas fa-calendar-alt me-1"></i>Add Event
              </div>
              <div className="tools">
                <button
                  type="button"
                  className="btn btn-sm btn-light border"
                  onClick={() => setCollapseBtn(!collapseBtn)}
                >
                  <i className={`fas ${collapseBtn ? "fa-angle-up" : "fa-angle-down"}`}></i>
                </button>
              </div>
            </div>

            <Collapse in={collapseBtn}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <form onSubmit={submitHandler}>
                    <div className="row">
                      <div className="col-xl-6">
                        <div className="mb-3">
                          <label className="form-label">Event Title</label>
                          <input
                            type="text"
                            className="form-control"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            placeholder="Enter event title"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Subtitle</label>
                          <input
                            type="text"
                            className="form-control"
                            name="subtitle"
                            value={formData.subtitle}
                            onChange={handleChange}
                            placeholder="Example: Upcoming Workshop"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Event Date</label>
                          <input
                            type="text"
                            className="form-control"
                            name="event_date"
                            value={formData.event_date}
                            onChange={handleChange}
                            placeholder="Example: April 08, 2026"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Location</label>
                          <input
                            type="text"
                            className="form-control"
                            name="location"
                            value={formData.location}
                            onChange={handleChange}
                            placeholder="Example: Vizag"
                          />
                        </div>
                      </div>

                      <div className="col-xl-6">
                        <div className="mb-3">
                          <label className="form-label">Event Description</label>
                          <textarea
                            className="form-control"
                            rows="10"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            placeholder="Write event details..."
                          ></textarea>
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Upload Event Image</label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={handleImage}
                            accept="image/*"
                          />
                        </div>

                        {image && (
                          <div className="mb-3">
                            <img
                              src={URL.createObjectURL(image)}
                              alt="Preview"
                              style={{
                                width: "100%",
                                maxHeight: "220px",
                                objectFit: "cover",
                                borderRadius: "12px",
                                border: "1px solid #ddd",
                              }}
                            />
                          </div>
                        )}
                      </div>

                      <div className="col-xl-12 text-end">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save Event"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Collapse>
          </div>
        </div>

        {/* EVENT LIST */}
        <div className="col-xl-12 mt-4">
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa">
                <i className="fas fa-list me-1"></i>Uploaded Events
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead>
                    <tr>
                      <th>Image</th>
                      <th>Title</th>
                      <th>Subtitle</th>
                      <th>Date</th>
                      <th>Location</th>
                      <th style={{ width: "170px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {events.length > 0 ? (
                      events.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <img
                              src={
                                item.image
                                  ? `https://admin.vascularirdoctors.com/backend${item.image}`
                                  : "https://via.placeholder.com/90x60?text=No+Image"
                              }
                              alt={item.title}
                              style={{
                                width: "90px",
                                height: "60px",
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                          </td>
                          <td>{item.title}</td>
                          <td>{item.subtitle}</td>
                          <td>{item.event_date}</td>
                          <td>{item.location}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-info me-2"
                              onClick={() => openEditModal(item)}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => confirmDelete(item.id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No events found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Event</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Title</label>
              <input
                type="text"
                className="form-control"
                name="title"
                value={editData.title}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Subtitle</label>
              <input
                type="text"
                className="form-control"
                name="subtitle"
                value={editData.subtitle}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Date</label>
              <input
                type="text"
                className="form-control"
                name="event_date"
                value={editData.event_date}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Location</label>
              <input
                type="text"
                className="form-control"
                name="location"
                value={editData.location}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-12 mb-3">
              <label>Description</label>
              <textarea
                className="form-control"
                rows="5"
                name="description"
                value={editData.description}
                onChange={handleEditChange}
              ></textarea>
            </div>

            <div className="col-md-12 mb-3">
              <label>Change Image</label>
              <input
                type="file"
                className="form-control"
                onChange={handleEditImage}
                accept="image/*"
              />
            </div>

            <div className="col-md-12">
              <img
                src={
                  editImage
                    ? URL.createObjectURL(editImage)
                    : editData.image
                    ? `https://admin.vascularirdoctors.com/backend${editData.image}`
                    : "https://via.placeholder.com/600x250?text=No+Image"
                }
                alt="Preview"
                style={{
                  width: "100%",
                  maxHeight: "250px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={updateEvent}>
            Update Event
          </Button>
        </Modal.Footer>
      </Modal>

      {/* DELETE CONFIRM MODAL */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Event</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this event? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={deleteEvent}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddEvent;